export default __webpack_public_path__ + "static/media/Cat_O_Banner_Mats_and_Runners_V2.cd7c6075.jpg";